import React from "react";
import {CButton} from "@coreui/react";
import {withErrorBoundary} from "../ErrorBoundary";
import {useTranslation} from "react-i18next";

const ReturnButton = ({className, size, color, variant, onReturnButtonClick, checkId, incidentId}) => {
  const {t} = useTranslation();

  return (
    <CButton
      className={className}
      size={size}
      color={color}
      variant={variant}
      onClick={() => onReturnButtonClick(checkId, incidentId)}
    >
      {t("button.return", "Return")}
    </CButton>
  );
};

ReturnButton.defaultProps = {
  className: "btn-block mt-1",
  size: "sm",
  color: "warning",
  variant: "outline",
};

export default withErrorBoundary(ReturnButton);